import ProAuthor from './ProAuthor'

export default class BestSellingAuthor extends ProAuthor {
  maxParticipantsPerArc = -1
  maxRunningArcs = 10
  canLimitReviewersToTopReviewersOnly = true
  canAccessPremiumSupport = true
  canUseAdvancedReviewIssueDetection = true
  canAddVirtualAssistants = true
  canViewExtendedReviewerInformation = true
  canHaveNeverEndingArcs = true
  canChooseDefaultReviewDisclaimer = true
}
